const prefix = 'SETUP_SETTINGS_GENERALSETTINGS_';

export const SET_GENERALSETTINGS_DATA = `${prefix}SET_GENERALSETTINGS_DATA`;



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/flow/actionType.js